import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SystemGlobalsService, NetworkEdition, Role } from '../system-globals.service';
import {Preset} from '../common/elements/elements.types';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})
export class StoreComponent implements OnInit {

  constructor(public globals: SystemGlobalsService,private http: HttpClient) { }
  networkId = this.globals.constants.networkID.toString();


  // @ts-ignore
  lc = this.globals.constants.networkName.replaceAll(" ", "").toLowerCase();
  isStoreOn: boolean = false;
  isMarketplaceVisible: boolean = true; // Default to visible
  showDisableConfirmation: boolean = false; // For confirmation modal
  
  ngOnInit() {
    this.getStore()
  }

  getStore() {
    this.http.get('/networks/getStore').subscribe(data => {
      this.isStoreOn = data['store_enabled'] == 1;
      this.isMarketplaceVisible = data['marketplace_visible'] == 1; // Get marketplace visibility status
    })
  }

  handlePanelClick(claim: string): void {
    this.http.post<{ store_enabled: boolean; login_token: string }>('/networks/getStoreToken', { claim })
      .subscribe({
        next: (response) => {
          if (response.store_enabled) {
            const token = response.login_token;
            const url = `${this.globals.constants._g_store_url}/auth/login?token=${token}`;
            window.open(url, '_blank');
          } else {
            alert('Store is not enabled for this network.');
          }
        },
        error: (error) => {
          console.error('Error fetching store token:', error);
        }   
       
      });
  }

  storeSwitch() {
    let payload = {
      status : 1 // Always enable when this method is called
    }

    this.http.post('/networks/saveStore', payload).subscribe((r)=>{
      console.log(r);
      this.isStoreOn = true; // Update local state
    })

    console.log('Store enabled');
  }

  // New methods for confirmation modal
  confirmDisable() {
    this.showDisableConfirmation = true;
  }

  cancelDisable() {
    this.showDisableConfirmation = false;
  }

  confirmDisableStore() {
    let payload = {
      status : 0 // Disable store
    }

    this.http.post('/networks/saveStore', payload).subscribe((r)=>{
      console.log(r);
      this.isStoreOn = false; // Update local state
      this.showDisableConfirmation = false; // Close modal
    })

    console.log('Store disabled');
  }

  marketplaceVisibilitySwitch() {
    // Only allow toggle if store is enabled
    if (!this.isStoreOn) {
      alert('Store must be enabled before changing marketplace visibility.');
      return;
    }

    let payload = {
      marketplace_visible: this.isMarketplaceVisible ? 1 : 0
    }

    this.http.post('/networks/saveMarketplaceVisibility', payload).subscribe((r) => {
      console.log('Marketplace visibility updated:', r);
    })
  }

  copyStoreUrl() {
    const url = `${this.globals.constants._g_store_url}/${this.lc}`;
    navigator.clipboard.writeText(url).then(() => {
      // Optionally, show a toast or alert for feedback
      console.log('Store URL copied to clipboard:', url);
    });
  }
}
